import { ChatAttachmentType } from '@agent/agent-interface/contact-view/chat/model/chat-attachment-type';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'chat-attachment',
  templateUrl: 'chat-attachment.component.html',
  styleUrls: ['./chat-attachment.component.scss'],
})
export class ChatAttachmentComponent {
  @Input()
  public filename: string;

  @Input()
  public size: number;

  getFileExtension() {
    const matches = this.filename.match(/[^.\\/:*?"<>|\r\n]+$/g);
    return matches && matches[0];
  }

  getClassName() {
    const extension = this.getFileExtension();
    const className = extension && ChatAttachmentType[extension.toUpperCase()];
    return className || 'cng-ico_star_favorite';
  }
}
